// this component was automatically generated by IconGlyph.template.js
import React from 'react';
import { TestId } from '@trello/test-ids';

import { Icon, IconColor, IconSize } from '../src/components/Icon';

export interface GlyphProps {
  /**
   * A string that is applied as an aria attribute on the icon. Usually it
   * matches up with the display name of the icon
   * @default If no label is provided, it will fallback to the name of the icon
   */
  label?: string;
  /**
   * The color that the Icon should be rendered as.
   * @default @icon-default-color (#42526E)
   */
  color?: IconColor;
  /**
   * The size to render the Icon size.
   * @default "medium"
   */
  size?: IconSize;
  /**
   * A string that gets placed as a data attribute (data-test-id) onto the
   * Icon wrapper so that our
   * smoketest can properly target and test the component
   * @default undefined
   */
  testId?: TestId;
  // Escape hatches
  /**
   * ⚠️ DO NOT USE THIS PROP UNLESS YOU REALLY REALLY HAVE TO.
   *
   * Places a class name on the Icon (more specifically, the svg itself). This
   * is placed in addition to the classes already placed on the Icon. This is
   * placed directly onto the SVG via the glyph templates that are
   * generated by IconGlyph.template.js
   *
   * Please refrain from using this unless absolutely necessary.
   * @default undefined
   */
  dangerous_className?: string;
}

const InstagramIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.996 7.372a4.624 4.624 0 100 9.247 4.624 4.624 0 000-9.247zm0 7.625a3.001 3.001 0 110-6.003 3.001 3.001 0 010 6.003z"
        fill="currentColor"
      />
      <path
        d="M16.802 8.27a1.08 1.08 0 100-2.161 1.08 1.08 0 000 2.16z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.996 2.992c-2.445 0-2.752.01-3.712.054-.958.044-1.613.196-2.186.419a4.413 4.413 0 00-1.594 1.038c-.5.5-.809 1.003-1.039 1.595-.222.573-.375 1.227-.418 2.186-.044.96-.055 1.267-.055 3.712 0 2.445.01 2.752.055 3.712.043.958.196 1.613.418 2.186.23.592.538 1.094 1.039 1.595.5.5 1.002.808 1.594 1.038.573.223 1.228.375 2.186.418.96.044 1.267.055 3.712.055 2.445 0 2.752-.01 3.713-.055.958-.043 1.612-.195 2.185-.418a4.414 4.414 0 001.595-1.039c.5-.5.808-1.002 1.038-1.594.223-.573.375-1.227.419-2.186.044-.96.054-1.267.054-3.712 0-2.445-.01-2.752-.054-3.712-.044-.959-.196-1.613-.419-2.186a4.413 4.413 0 00-1.038-1.595c-.5-.5-1.003-.808-1.595-1.038-.573-.223-1.227-.375-2.185-.419-.96-.044-1.268-.054-3.713-.054zm0 1.622c2.404 0 2.69.01 3.638.053.878.04 1.355.187 1.672.31.42.163.72.358 1.036.673.315.315.51.615.673 1.036.123.317.27.794.31 1.672.044.949.053 1.234.053 3.638s-.01 2.689-.053 3.638c-.04.878-.186 1.355-.31 1.672a2.79 2.79 0 01-.673 1.035c-.315.315-.615.51-1.036.674-.317.123-.794.27-1.672.31-.949.043-1.234.052-3.638.052s-2.689-.009-3.638-.052c-.878-.04-1.355-.187-1.672-.31a2.789 2.789 0 01-1.035-.674 2.79 2.79 0 01-.674-1.035c-.123-.317-.27-.794-.31-1.672-.043-.95-.052-1.234-.052-3.638s.009-2.689.052-3.638c.04-.878.187-1.355.31-1.672.164-.42.359-.72.674-1.036a2.79 2.79 0 011.035-.673c.317-.123.794-.27 1.672-.31.95-.043 1.234-.053 3.638-.053z"
        fill="currentColor"
      />
    </svg>
  );
};

export const InstagramIcon: React.FunctionComponent<GlyphProps> = (props) => {
  const { testId, dangerous_className, size, color, label } = props;
  return (
    <Icon
      testId={testId}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      label={label || 'InstagramIcon'}
      glyph={InstagramIconGlyph}
    />
  );
};
